<template>
  <transition>
    <div class="modal-container" v-show="isShowCookie">
      <div class="body">
        <div class="content">
          beanfun! 採用網站分析技術為您帶來更優質的使用體驗，若您點選 "我同意"
          或繼續瀏覽本網站，即表示您同意我們使用第三方
          Cookie，欲瞭解更多資訊請見
          <a href="https://www.beanfun.com/terms" target="blank">隱私權政策</a
          >。
        </div>
      </div>
      <div class="footer">
        <BTrackingClickEvent 
              event="comics_event_comic_music_global_item_click"
              eventId="8503"
              :pageInfo="{tab:''}"
              :clickInfo="{name:'cookie'}"
              >
        <div class="btn" @click="cookieClose">我同意</div>
        </BTrackingClickEvent>
      </div>
    </div>
  </transition>
</template>

<script lang="ts">
// import { fa } from "element-plus/es/locale/index.mjs";
import { ref, computed, onMounted, watch } from "vue";
import BTrackingClickEvent from '@/components/BTracking/BTrackingClickEvent.vue';

export default {
  props: {},
  components:{
    BTrackingClickEvent,
  },
  setup() {
    const isShowCookie = ref(true);
    const cookieClose = () => {
      console.log("aaa");
      isShowCookie.value = false;
      localStorage.setItem("20231109_agreeCookie", "1");
    };
    onMounted(() => {
      var setting = localStorage.getItem("20231109_agreeCookie") as string;
      if (undefined == setting && null == setting) {
        isShowCookie.value = true;
      } else {
        isShowCookie.value = false;
      }
    });
    return {
      isShowCookie,
      cookieClose,
    };
  },
};
</script>

<style scoped>
.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}
.modal-enter-active {
  transition-timing-function: "ease-out";
}
.modal-leave-active {
  transition-timing-function: "ease-in";
}
.modal-enter-active,
.modal-leave-active {
  transition-duration: 200ms;
}
.modal-enter-from.modal-container,
.modal-leave-to.modal-container {
  transform: scale(0.9) translateY(-2rem);
}
.body {
  margin-right: 20px;
}
.body .content {
  font-family: Noto Sans TC;
  font-size: 14px;
  font-weight: 400;
  line-height: 30px;
  letter-spacing: 0em;
  text-align: left;
  color: #000000;
}
.body .content a {
  color: #26d07c;
  text-decoration-line: underline;
}
.modal-container {
  display: flex;
  align-items: center;
  width: 100%;
  margin: auto;
  max-width: 1140px;
  border-radius: 10px;
  padding: 12px 69px;
  box-shadow: 0px 1px 20px 0px rgba(0, 0, 0, 0.1);
  background: rgba(255, 255, 255, 0.9);
  position: fixed;
  left: 0;
  right: 0;
  bottom: 24px;
  z-index: 20;
}
.btn {
  width: 134px;
  font-family: Noto Sans TC;
  font-size: 18px;
  font-weight: 500;
  line-height: 26px;
  letter-spacing: 0em;
  text-align: left;
  color: #ffffff;
  padding: 16px 40px;
  border-radius: 10px;
  background: #3c3c3c;
  cursor: pointer;
}
@media screen and (max-width: 800px) {
  .body {
    margin-right: 0px;
    margin-bottom: 20px;
  }
  .body .content {
    font-family: Noto Sans TC;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;
    color: #000000;
    text-align: justify;
  }
  .body .content a {
    color: #26d07c;
    text-decoration-line: underline;
  }
  .modal-container {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    width: 95%;
    margin: auto;
    padding: 12px;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 16px;
    z-index: 20;
  }
  .btn {
    width: 106px;
    font-size: 14px;
    line-height: 20.27px;
    padding: 12px 32px;
  }
}
</style>
